import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';

@Injectable()
export class AuthguardService implements CanActivate {

  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot) {
    let returnValue: boolean = false;
    let userInfo: any = JSON.parse(sessionStorage.getItem('currentUser'));
    if (!sessionStorage.getItem('authToken')) {
      this.router.navigate(['/login']);
      return false;
    }
    else if (!route || !route.url)
      returnValue = false;
    else if (route.url.length < 1)
      returnValue = true;
    else if (route.url[0].path==="user-management") {
      if (!userInfo.admin || userInfo.admin == false)
        returnValue = false;
      else
        returnValue = true;
    }
    else if (route.url[0].path==="client-management") {
      if (!userInfo.admin || userInfo.admin == false)
        returnValue = false;
      else
        returnValue = true;
    }
    else if (route.url[0].path=="payroll-log") {
        if (userInfo.externalUser == false)
          returnValue = true;
        else
          returnValue = false;
    }
    else if (route.url[0].path=="log-book") {
        if (userInfo.externalUser == false)
          returnValue = true;
        else
          returnValue = false;
    }
    else if (route.url[0].path=="reports") {
      if (userInfo.externalUser == false)
        returnValue = true;
      else
        returnValue = false;
    }
    else {
      returnValue = true;
    }
    return returnValue;
  }
    
}




// WEBPACK FOOTER //
// ./src/app/common/services/authguard.service.ts